import React from 'react';
import MarkdownBody from './MarkdownBody';
import StructuredExtras from './StructuredExtras';

function JsonFallback({ data, raw }) {
    const payload = data ?? safeParse(raw);
    return (
        <pre className="text-[12px] font-mono text-[#475569] bg-[#F8FAFC] border border-[#E2E8F0] rounded-[8px] p-[12px] overflow-x-auto">
            {payload ? JSON.stringify(payload, null, 2) : raw || '(không có nội dung)'}
        </pre>
    );
}

function safeParse(raw) {
    if (raw == null || typeof raw !== 'string') return null;
    try { return JSON.parse(raw); } catch { return null; }
}

function RenderedBody({ contentType, content, structured }) {
    if (!content) {
        return structured ? <JsonFallback data={structured} /> : null;
    }
    if (contentType === 'json') return <JsonFallback raw={content} />;
    if (contentType === 'html') {
        return <div className="prose prose-sm max-w-none [&>*:first-child]:!mt-0 [&>*:last-child]:!mb-0" dangerouslySetInnerHTML={{ __html: content }} />;
    }
    if (contentType === 'text') {
        return <pre className="whitespace-pre-wrap text-[14px] text-[#334155] !mt-0 !mb-0">{content}</pre>;
    }
    return <MarkdownBody text={content} className="[&>*:first-child]:!mt-0 [&>*:last-child]:!mb-0" />;
}

export default function InsightBody({ detail }) {
    if (!detail) return null;
    return (
        <section className="flex flex-col gap-[16px]">
            <div className="bg-white border border-[#E5E7EB] rounded-[12px] p-[16px] sm:p-[24px_32px] md:p-[32px_48px]">
                <RenderedBody
                    contentType={detail.content_type}
                    content={detail.content}
                    structured={detail.structured}
                />
            </div>
            <div data-no-print><StructuredExtras structured={detail.structured} /></div>
        </section>
    );
}
